import React from 'react'
import {browserHistory, Route, Router} from 'react-router'
import Documentation from './Page/Documentation'

export default _ =>
  <Router history={browserHistory}>
    <Route path="/documentation" component={Documentation}/>
  </Router>



// WEBPACK FOOTER //
// ./app/App/Module/Documentation/index.js